export var globals = {
	showDebugForComponents: false,
	showDebugAnswerTypes: false,
	isMuted: false,
	memory: '',
	queryMemory: false
};